import React from 'react';
import { Message, ActionProposalMessage, ActivityBlockMessage, ResultCardMessage } from '../types/space';
import { MessageBubble } from './MessageBubble';
import { HistoryMarker } from './HistoryMarker';
import { ActionCard } from './ActionCard';
import { ActivityBlock } from './ActivityBlock';
import { ResultCard } from './ResultCard';
interface ConversationStreamProps {
  messages: Message[];
  onConfirmAction: (id: string) => void;
  onSkipAction: (id: string) => void;
  onToggleActivityDetails: (id: string) => void;
  bottomRef: RefObject<HTMLDivElement>;
}
export function ConversationStream({
  messages,
  onConfirmAction,
  onSkipAction,
  onToggleActivityDetails,
  bottomRef
}: ConversationStreamProps) {
  return <div className="flex-1 overflow-y-auto px-6 py-6 scroll-smooth" data-id="element-61">
      <div className="max-w-3xl mx-auto pb-4" data-id="element-62">
        {messages.map(msg => {
        switch (msg.type) {
          case 'user':
          case 'system':
            return <MessageBubble key={msg.id} message={msg} data-id="element-63" />;
          case 'history-marker':
            return <HistoryMarker key={msg.id} label={msg.label} data-id="element-64" />;
          case 'action-proposal':
            return <ActionCard key={msg.id} message={msg as ActionProposalMessage} onConfirm={onConfirmAction} onSkip={onSkipAction} data-id="element-65" />;
          case 'activity':
            return <ActivityBlock key={msg.id} message={msg as ActivityBlockMessage} onToggleDetails={onToggleActivityDetails} data-id="element-66" />;
          case 'result':
            return <ResultCard key={msg.id} message={msg as ResultCardMessage} data-id="element-67" />;
          default:
            return null;
        }
      })}
        <div ref={bottomRef} className="h-4" data-id="element-68" />
      </div>
    </div>;
}